import styled from 'styled-components';

export const TypesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 25px;
  margin-top: 30px;
  align-items: stretch;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const TypeItem = styled.div`
  border-radius: 14.044px;
  border: 1.756px solid #E7E0EC;
  padding: 0px 20px 28.089px 20px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const TypeDescription = styled.span`
  color: #3C3B3B;
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  margin-top: 17px;
`;

export const TypeImage = styled.img`
  width: 203px;
  height: 141px;
  margin: 30px 20px 0 20px;
`;

export const TypeTitle = styled.div`
  color: #3C3B3B;
  font-family: Poppins-Regular;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin-top: 17px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  min-height: 48px;
`;

export const TypeRadio = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1.5px solid #C4C4C4;
  outline: none;
  cursor: pointer;

  &:checked {
    border-color: #D40020;
    box-shadow: inset 0 0 0 3px #fff, 0 0 0 1.5px #D40020;
  }
`;

export const LoadingRow = styled.div`
  width: 100%;
  paddind: 40px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;